import { fileUrl, imgUrl } from "@/lib/api";

/**
 * Site logo: the uploaded image served as a small WebP rendition (96px, 2× for 44px boxes) with fixed dimensions and eager
 * decoding so the header never shifts or waits; fallback square "ع.س".
 * size: tailwind pixel dimension classes e.g. "h-10 w-10"
 */
export default function Logo({ logoUrl, size = "h-10 w-10", textSize = "text-base" }) {
    if (logoUrl) {
        const small = imgUrl(logoUrl, 96), big = imgUrl(logoUrl, 128);
        return <img src={small} srcSet={small !== fileUrl(logoUrl) ? `${small} 96w, ${big} 128w` : undefined} sizes="48px" width={48} height={48} alt="logo" loading="eager" fetchpriority="high" decoding="sync"
            className={`${size} rounded-sm object-cover shrink-0 bg-white`} data-testid="site-logo" />;
    }
    return (
        <div className={`${size} rounded-sm bg-brand-red text-white flex items-center justify-center font-black font-display shrink-0 ${textSize}`}>ع.س</div>
    );
}
